import React, { useMemo } from "react";
import { Box } from "@mui/material";

import CheckinFallback from "../../assets/Checkin.svg";
import CheckinImageMorning from "../../assets/checkins/card-img/morning checkin1.jpg";
import CheckinImageMidday from "../../assets/checkins/card-img/Mid-Day Check-in1 .jpg";
import CheckinImageNight from "../../assets/checkins/card-img/Nightly Reflection checkin 1.jpg";

import CheckinsCarousel from "./CheckinsCarousel";

const CheckinsSection = ({
  titleTooltip,
  onOpen,
  isMorningCompleted,
  isMiddayCompleted,
  isNightCompleted,
  allCompleted,
}) => {
  const items = useMemo(
    () => [
      {
        dialogType: "daily",
        categoryTitle: "Morning Focus Check-in",
        title: "Morning Focus Check-in",
        description:
          "Take one minute to set your intention for today, choose what you want to focus on, and notice what might get in the way. A quick reset to start your day feeling clear and grounded.",
        tooltip:
          "Good Morning! 1 Minute: Set your focus and intention for the day",
        imageSrc: CheckinImageMorning,
        imageAlt: "Morning check-in",
        fallbackSrc: CheckinFallback,
        isDisabled: false,
        isCompleted: isMorningCompleted,
      },
      {
        dialogType: "growth",
        categoryTitle: "Mid-Day Check-in",
        title: "Mid-Day Check-in",
        description:
          "Pause for a minute to capture your best win so far, reflect on what helped you get there, and reconnect with what matters for the rest of the day. Keep your momentum without overthinking.",
        tooltip:
          "1 Minute Recharge: Log your Best Win and track your progress.",
        imageSrc: CheckinImageMidday,
        imageAlt: "Mid-day check-in",
        fallbackSrc: CheckinFallback,
        isDisabled: !isMorningCompleted && !allCompleted,
        isCompleted: isMiddayCompleted,
      },
      {
        dialogType: "reflect",
        categoryTitle: "Nightly Reflection",
        title: "Nightly Reflection",
        description:
          "End your day with a short reflection: how you felt, what went well, and what you want to carry forward. A simple way to learn from your day and close out with intention.",
        tooltip: "Day Done? 1 Minute: Reflect on your day and Grow",
        imageSrc: CheckinImageNight,
        imageAlt: "Nightly reflection",
        fallbackSrc: CheckinFallback,
        isDisabled: !isMiddayCompleted && !allCompleted,
        isCompleted: isNightCompleted,
      },
    ],
    [isMorningCompleted, isMiddayCompleted, isNightCompleted, allCompleted]
  );

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ width: "100%", mt: 1 }} aria-label={titleTooltip}>
        <CheckinsCarousel items={items} onOpen={onOpen} />
      </Box>
    </Box>
  );
};

export default CheckinsSection;
